import React from "react";
import { Button, Card, Col } from "react-bootstrap";
import styled from "styled-components";
import { formatearFechaStr } from "../../../utils/dateUtils";
import CardTitle from "../../organisms/CardTitle";
import TableSection from "./TableSection";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { ListaAsistenciaProyectadaSpa } from "../../../services/asistenciaSpaServicios";

function DetailSection({
  listaProyectada,
}: {
  listaProyectada: ListaAsistenciaProyectadaSpa;
}) {
  let nagivate = useNavigate();

  const onEditarListaClick = (id: string) => {
    nagivate(`/asistencia_spa/checkin/${id}`);
  };

  return (
    <StyledCard>
      <StyledCardHeader className="mt-3">
        <Col>
          <CardTitle>{generarTitulo(listaProyectada)}</CardTitle>
        </Col>
        <Col className="d-flex justify-content-end">
          {listaProyectada.tipo === "PASADA" && (
            <Button
              size="sm"
              variant="outline-primary"
              onClick={() => {
                onEditarListaClick(listaProyectada.idLista);
              }}
            >
              Editar lista <EditIcon fontSize="inherit" />
            </Button>
          )}
        </Col>
      </StyledCardHeader>
      <StyledCardBody>
        <div className="mb-3">
          <b>{"Fecha: "}</b>
          {formatearFechaStr(listaProyectada.fecha)}
        </div>
        <div className="mb-3">
          <b>{"Conteo: "}</b>
          {listaProyectada.conteoMascotas + " mascotas"}
        </div>
        <TableSection
          asistenciasProyectadas={listaProyectada.asistencias}
          fecha={listaProyectada.fecha}
        />
      </StyledCardBody>
    </StyledCard>
  );
}

const generarTitulo = (listaProyectada: ListaAsistenciaProyectadaSpa) => {
  switch (listaProyectada.tipo) {
    case "PASADA":
      return "Lista de asistencia";
    case "FUTURA":
      return "Proyección de asistencia";
    default:
      return "";
  }
};

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;

export default DetailSection;
